import PropTypes from 'prop-types'
import { Redirect } from 'react-router-dom'

import injectRole from '../../../components/HOC/injectRole'

import { TRoutes } from '../../../shared/const'
import { mayOpenAdminPage } from '../../../shared/alumni'
import Companies from '../../../components/views/admin/Companies'

function CompaniesPage(props) {
	if (mayOpenAdminPage(props.role, 'companies')) return <Companies />
	else return <Redirect to={TRoutes.DASHBOARD} />
}

CompaniesPage.propTypes = {
	role: PropTypes.string.isRequired
}

export default injectRole(CompaniesPage)
